import { createContext } from 'react';
import { createMachine } from "xstate";


//models
// import { User } from '../Models/User'
import { CartCard } from '../Models/CartCards';


export const cartShopMachine = createMachine({
    id: "cartShopDataFetch",
    initial: "wating",
    context: { cart: {productos:[], total:0, totalCash:0, nProducts:0},} as { cart: CartCard},
    states: {
      wating: {
        on: {
            ADD: { target: "adding"  },
            DISC: { target: "discounting"  },
            EDIT: { target: "edit"  },
            SET: { target: "charge"  },
            DELETE: { target: "delete"  },

        },
        entry: "calculateCart",

      },
      adding: {
        after: { 50: "wating" },
        entry: "addCart",
      },
      charge: {
        after: { 50: "wating" },
        entry: "chargeCart",
      },
      discounting: {
        after: { 50: "wating" },
        entry: "supCart",
      },
      edit: {
        after: { 50: "wating" },
        entry: "editQuantity",
      },
      delete: {
        after: { 50: "wating" },
        entry: "deleteCart",
      },

    },
  }, 
      /* actions */
  { actions: {
      // action implementations
     calculateCart:(context, event) => {
        let cartAux = context.cart
        let cantidad = 0
        let total = 0
        let totalCash = 0

        for (let index = 0; index < cartAux.productos.length; index++) {
          let element = cartAux.productos[index];
          cartAux.productos[index].subTotal = element.producto.product.price * element.cantidad 
          cartAux.productos[index].subTotalCash = element.producto.product.cash_price * element.cantidad 
          cantidad+= element.cantidad
          total+= element.producto.product.price * element.cantidad 
          totalCash+= element.producto.product.cash_price * element.cantidad 
        }
        cartAux.nProducts = cantidad
        cartAux.total = total
        cartAux.totalCash =totalCash
        context.cart = cartAux

      },

      chargeCart:(context, event) => {
        context.cart = event.data.cart;
      },

      deleteCart:(context, event) => {
        context.cart = {productos:[], total:0, nProducts:0, totalCash:0}
      },

      addCart:(context, event) => {
        let cartAux = context.cart
        let inventaryAux = event.data.producto;


        if(!cartAux.productos.find(x => x.producto.id === inventaryAux.id)){
            cartAux.productos.push({producto: event.data.producto , cantidad:1, subTotal: event.data.producto.product.price, subTotalCash: event.data.producto.product.cash_price, type:"card"})
        }

        context.cart = cartAux

      },

      supCart:(context, event) => {
        let cartAux = context.cart
        let inventaryAux = event.data.producto;

        cartAux.productos = cartAux.productos.filter(x => x.producto.id !== inventaryAux.id)

        context.cart = cartAux

      },

      editQuantity:(context, event) => {
        let cartAux = context.cart
        let inventaryAux = event.data.producto;
        let quantity = event.data.quantity

        for (let index = 0; index < cartAux.productos.length; index++) {
          let element = cartAux.productos[index];

          if(element.producto.id === inventaryAux.id){
            cartAux.productos[index].cantidad = quantity
          }
        }

        context.cart = cartAux

      },

    }
  });
